import { render, staticRenderFns } from "./DomainVerificationInput.vue?vue&type=template&id=ffb15b2a&"
import script from "./DomainVerificationInput.vue?vue&type=script&lang=js&"
export * from "./DomainVerificationInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports